import { openClientContactModal } from '../../../State/clientContactModal'

export default () => (dispatch) => {

  dispatch(openClientContactModal())

}
